import React from 'react';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { BrowserRouter } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'react-toastify/dist/ReactToastify.css';

import Router from '@core/routes';
import AxiosInterceptor from '@core/api/AxiosInterceptors';

import theme from './styles/mui-theme';
import './App.scss';
import { AppProvider } from './App.context';
import { Slide, ToastContainer } from "react-toastify";

function App() {
    return (
        <BrowserRouter>
            <AxiosInterceptor>
                <ThemeProvider theme={theme}>
                    <CssBaseline />
                    <AppProvider>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <ToastContainer
                                position="bottom-right"
                                style={{ transform: 'translateY(-40px)' }}
                                autoClose={3000}
                                hideProgressBar
                                closeOnClick
                                theme="colored"
                                transition={Slide}
                            />
                            <Router />
                        </LocalizationProvider>
                    </AppProvider>
                </ThemeProvider>
            </AxiosInterceptor>
        </BrowserRouter>
    );
}

export default App;
